import { action, computed, observable } from 'mobx';
import httpFacade from 'http/httpFacade';
import { Email } from 'http/Api/Email/types';
import { PromiseService } from 'services/PromiseService';

class EmailViewModalStore {
  @observable email: Email | null = null;

  @observable private _promiseService = new PromiseService();
  private _id = '';

  constructor(id: string) {
    this._id = id;
  }

  @action.bound
  async init() {
    const { data } = await this._promiseService.add(() =>
      httpFacade.email.fetchEmailById(this._id),
    );

    this.email = data;
  }

  @computed
  get isLoading() {
    return this._promiseService.isPending || !this._promiseService.isCompleted;
  }
}

export default EmailViewModalStore;
